import React, { useCallback, useState, useEffect } from "react";

import { DialogContent, Fab, Tooltip, ClickAwayListener } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Support from "../../../container/SupportModal/Modal.js";
import Modal from "../../../HOC/modal/Modal";
import useHeaderStyles from "../Header.styles.js";
import useNotificationStyles from "./Notification.styles.js";
import NotificationDropdown from "./NotificationDropdown";
import {
  getNotificationsStart,
  selectNotifications,
  startNotificationSocket,
} from "../../../redux-saga/redux/notifications/notifications";

const Contact = ({ handleOpenSignUp }) => {
  const [openContact, setOpenContact] = useState(false);
  const [openNotifications, setOpenNotifications] = useState(false);
  const classes = useHeaderStyles();
  const notifClasses = useNotificationStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const notificationsState = useSelector(selectNotifications) || {};
  const { pagination = {} } = notificationsState;
  const totalRecords = pagination.totalRecords || 0;
  const { isLoggedIn } = useSelector((state) => state.authentication);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getNotificationsStart());
      dispatch(startNotificationSocket());
    }
  }, [dispatch, isLoggedIn]);

  const handleOpenLogin = useCallback(() => {
    setOpenContact((prevState) => !prevState);
  }, []);

  const handleCloseNotification = () => setOpenNotifications(false);

  return (
    <>
      <ClickAwayListener
        onClickAway={() => setOpenNotifications(false)}
        touchEvent={false}
      >
        <div style={{ position: "relative" }}>
          {totalRecords > 0 && (
            <div className={notifClasses.notificationCountBadge}>
              {totalRecords}
            </div>
          )}
          <Tooltip
            arrow
            classes={{
              tooltip: classes.toolTipWrap,
              arrow: classes.toolTipArrow,
            }}
            className={classes.toolTipWrap}
            title={!openNotifications ? t("LOBBY.NEW_NOTIFICATION") : ""}
            placement="bottom"
          >
            <Fab
              size="small"
              onClick={() => setOpenNotifications((prev) => !prev)}
              sx={{
                "&&": {
                  backgroundColor: theme?.palette?.appHeaderButtonBG?.red,
                  borderRadius: "50%",
                  height: "40px",
                  width: "40px",
                },
                "& img": { transition: "filter 0.3s ease" },
                "&:hover": {
                  backgroundColor: theme?.palette?.appHeaderButtonBG?.active,
                  "& img": { filter: "brightness(0)" },
                },
              }}
            >
              <img
                style={{ height: "20px", width: "20px" }}
                src="/images/notification.png"
                alt="notification"
              />
            </Fab>
          </Tooltip>
          {openNotifications && <NotificationDropdown onClose={handleCloseNotification} />}
        </div>
      </ClickAwayListener>

      <Tooltip
        arrow
        classes={{
          tooltip: classes.toolTipWrap,
          arrow: classes.toolTipArrow
        }}
        className={classes.toolTipWrap}
        title={t("LOBBY.CONTACT_US")}
        placement="bottom"
      >
        <Fab
          className={classes.contactButton}
          size="small"
          onClick={() => handleOpenLogin()}
        >
          <HeadsetMicIcon />
        </Fab>
      </Tooltip>
      <Modal
        isShowing={openContact}
        maxWidth={isMobile ? "90%" : ""}
        maxHeight={isMobile ? "90%" : ""}
        content={
          <DialogContent className={classes.signupWrap}>
            <Support setModalopen={setOpenContact} />
          </DialogContent>
        }
        hide={handleOpenSignUp}
      />
    </>
  );
};

export default Contact;
